export default __webpack_public_path__ + "static/media/otherscreen.85e66ac0.jpg";